export function Slider({
  min = 0,
  max = 5,
  step = 1,
  value,
  onChange,
  labels = [],
  className = '',
  disabled = false,
}) {
  const stepCount = Math.round((max - min) / step);
  const ratio = stepCount > 0 ? (value - min) / (max - min) : 0;
  const currentLabel = labels[Math.round((value - min) / step)];

  const handleChange = (e) => {
    onChange(Number(e.target.value));
  };

  const handleTrackClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const snapped = min + Math.round(x * stepCount) * step;
    const clamped = Math.min(max, Math.max(min, snapped));
    onChange(clamped);
    e.currentTarget.querySelector('input')?.focus?.();
  };

  return (
    <div
      className={`slider ${className}`}
      role="slider"
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={value}
      aria-valuetext={currentLabel ? `${currentLabel} (${Math.round(ratio * 100)}%)` : String(value)}
      aria-disabled={disabled}
      style={{ '--ratio': ratio, '--step-count': stepCount }}
    >
      <div className="slider__control">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          className="slider__input"
          aria-label="Font size scale"
        />
        <div className="slider__track" onClick={disabled ? undefined : handleTrackClick}>
          <div className="slider__track-fill" />
          <div className="slider__track-ticks" role="presentation">
            {Array.from({ length: stepCount + 1 }, (_, i) => (
              <span key={i} className="slider__tick" style={{ '--i': i }} />
            ))}
          </div>
          <div className="slider__thumb" />
        </div>
      </div>

      {labels.length > 0 && (
        <div className="slider__labels" role="presentation">
          {labels.map((label, index) => (
            <span
              key={index}
              className={`slider__label ${Math.round(value) === index ? 'slider__label--active' : ''}`}
            >
              <span className="slider__label-text">{label}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}